<div class="content-loaf">
  <div class="col-12">
    <h2>広域災害ＩＣＴ</h2>
  </div>

  <hr />

  <div class="col-12">
    <span>各医療機関の状況を一覧にしたファイルをダウンロードします。</span>
  </div>

  <div class="col-12">
    <a name="download" type="button" class="btn btn-primary btn-primary-gradient download-btn" href="../api/ClinicStatus/Download/">ダウンロード</a>
  </div>
</div>
